import {
  AccessControlDto,
  CreateAccessControlDto,
  KnownCreateAccessControlDtoType,
  UpdateAccessControlDto
} from '@groundfloor-platform/mgmt-service-g-sdk';
import { AccessControlForm } from './form';

export class AccessControlFormOutput {
  attachedToId?: string;
  type?: KnownCreateAccessControlDtoType;
  instructions?: string;
  codes?: string[];

  constructor(form: AccessControlForm) {
    if (form.attachedToId) this.attachedToId = form.attachedToId;
    if (form.type) this.type = form.type;
    if (form.instructions) this.instructions = form.instructions;
    if (form.codes) this.codes = form.codes;
  }

  static FromDto(dto: AccessControlDto, parentEntityId: string): AccessControlForm {
    return {
      attachedToId: parentEntityId,
      type: dto.type as KnownCreateAccessControlDtoType,
      instructions: dto.instructions,
      codes: dto.accessCodes?.codes ?? []
    };
  }

  static ToCreateDto(output: AccessControlFormOutput): CreateAccessControlDto {
    return {
      attachedToId: output.attachedToId!,
      type: output.type!,
      instructions: output.instructions!
    };
  }

  static ToEditDto(output: AccessControlFormOutput): UpdateAccessControlDto {
    return {
      instructions: output.instructions
    };
  }
}
